export default __webpack_public_path__ + "static/tile-overview-dark-289822be92b4ce103f9c10d469a0dd312757b1af327f03e0ae0b9637437782fc.png";